import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <Container style={{ maxWidth: '800px' }} className="py-4">
        <Button
          variant="link"
          className="text-decoration-none mb-3 p-0"
          onClick={() => navigate('/')}
        >
          <i className="bi bi-arrow-left me-2"></i>Back
        </Button>

        <h1>Terms of Service</h1>
        <p className="text-muted">Last updated: June 1, 2026</p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using Plum ("the Service"), operated by Plum Applications, Inc.
          ("we", "us", or "our"), you agree to be bound by these Terms of Service.
          If you do not agree to these terms, do not use the Service.
        </p>

        <h2>2. Description of Service</h2>
        <p>
          Plum is an AI-powered renovation planning tool that helps homeowners and
          property investors create detailed renovation requirements documents through
          a conversational interface. The Service generates contractor-ready
          specifications based on your inputs.
        </p>

        <h2>3. Account Registration</h2>
        <p>
          You must sign in with a Google account to use the Service. You are
          responsible for maintaining the security of your account and for all
          activities that occur under it. You must be at least 18 years old to
          use the Service.
        </p>

        <h2>4. Subscription Plans and Payments</h2>
        <p>
          Plum offers free and paid subscription tiers. Paid subscriptions are billed
          monthly through Stripe. You may cancel your subscription at any time through
          the Profile page. Cancellations take effect at the end of the current billing
          period. We reserve the right to change pricing with 30 days' notice.
        </p>

        <h2>5. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service for any unlawful purpose</li>
          <li>Attempt to gain unauthorized access to the Service or its systems</li>
          <li>Interfere with or disrupt the Service or its infrastructure</li>
          <li>Upload malicious content or attempt to exploit the AI system</li>
          <li>Resell or redistribute the Service without our written consent</li>
          <li>Use automated systems to excessively access the Service</li>
        </ul>

        <h2>6. Intellectual Property</h2>
        <p>
          You retain ownership of the content you provide to the Service. The
          renovation documents generated by the Service are yours to use. However,
          the Service itself, including its AI models, software, branding, and design,
          remains our intellectual property.
        </p>

        <h2>7. AI-Generated Content Disclaimer</h2>
        <p>
          The renovation plans and specifications generated by Plum are AI-assisted
          suggestions and should not be considered professional architectural,
          engineering, or legal advice. You should always consult qualified
          professionals before beginning any renovation project. We are not
          responsible for decisions made based on AI-generated content.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Plum and its affiliates shall not
          be liable for any indirect, incidental, special, consequential, or punitive
          damages, or any loss of profits, data, or goodwill arising from your use
          of the Service.
        </p>

        <h2>9. Data and Privacy</h2>
        <p>
          Your use of the Service is also governed by our{' '}
          <a href="/privacy">Privacy Policy</a>, which describes how we collect,
          use, and protect your personal information.
        </p>

        <h2>10. Termination</h2>
        <p>
          We may suspend or terminate your access to the Service at any time for
          violation of these Terms or for any other reason at our discretion. You
          may delete your account at any time through the Profile page, which will
          permanently remove all your data.
        </p>

        <h2>11. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. We will notify you of
          material changes by posting the updated Terms on this page with a new
          "Last updated" date. Continued use of the Service after changes
          constitutes acceptance of the revised Terms.
        </p>

        <h2>12. Contact</h2>
        <p>
          If you have questions about these Terms, please contact us at{' '}
          <a href="mailto:support@plum-app.com">support@plum-app.com</a>.
        </p>
      </Container>
    </div>
  );
}

export default TermsPage;
